// extracted by mini-css-extract-plugin
export default {"main_page_container":"styles_main_page_container__bhZ6X"};